import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as DemoService from 'services/users/demo';

export const useDemoService = () => {
  const { token } = useSelector((store) => store.user_data);

  const bookMeeting = async (options = {}) => {
    const { error, payload } = await DemoService.create({ ...options, token });
    if (error) {
      toast.error('Unable to request meeting at this time.');
      return null;
    }

    return payload;
  };

  return {
    bookMeeting
  };
};
